import { FC } from 'react'
import ReactModal from 'react-modal'
import { ModalProps as Props } from './types'
import styles from './Modal.module.scss'
import { contentStyles, overlayStyles } from './constants'
import classNames from 'classnames'

export const Modal: FC<Props> = ({ isOpen, onRequestClose, title, children, className, style = {} }) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    style={{ overlay: { ...overlayStyles }, content: { ...contentStyles, ...style } }}
  >
    <div className={styles['bolt-modal']}>
      <div className={styles.title}>{title}</div>
      <button className={styles.close} onClick={onRequestClose}>
        &times;
      </button>

      {isOpen && <div className={classNames(styles.content, className || '')}>{children}</div>}
    </div>
  </ReactModal>
)

ReactModal.setAppElement('#modal-root')
